<template>
  <md-button v-if="isVisible" :class="buttonClass" @click="changeStatus">
    <span class="md-label">
      <md-icon class="material-icons">{{ icon }}</md-icon>
    </span>
    {{ text }}
  </md-button>
</template>

<script>
export default {
  name: "status-button",
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    classColour: {
      type: String,
      default: "Add"
    },
    icon: {
      type: String,
      default: "Add"
    },
    text: {
      type: String,
      default: "Add"
    },
    statusId: {
      type: Number,
      default: 0
    },
    role: {
      type: Number,
      default: undefined,
      validator: function(value) {
        return [100].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    isVisible() {
      if (!this.$auth.isInGlobalRole()) {
        if (!this.$auth.isInRole(this.role)) return false;
        else return this.visible;
      } else return this.visible;
    },
    buttonClass() {
      return "md-" + this.classColour + " md-sm";
    }
  },
  methods: {
    changeStatus() {
      this.$emit("change-status", this.statusId);
    }
  }
};
</script>

<style>
.add-button {
  float: right;
  margin-top: 10px !important;
}
</style>
